import TopProductCard, {EmptyTopProductCard} from "./TopProductCard";
import React, {useContext, useEffect} from "react";
import {vendorGetTopProducts} from "../../../services/api/dashboard";
import {DropDownMenu} from "../../DropDown";
import {defaultDateRange, getDateRange} from "../utils";
import {AuthContext} from "../../../context/AuthContext";
import {Card} from "flowbite-react";
import {ArrowRight} from "react-feather";
import {VENDOR_CHART_IS_ESSENTIAL} from "../../../services/constants/VendorDashboardPackages";

const TopProducts = () => {
    const [topProducts, setTopProducts] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [topProductsRange, setTopProductsRange] = React.useState(90);
    const {company, baseUrl} = useContext(AuthContext);

    const getTopProducts = async () => {
        try {
            setIsLoaded(false);
            setTopProducts([]);
            const range = getDateRange(topProductsRange);
            const {data} = await vendorGetTopProducts(range.from, range.to);
            setTopProducts(data);
            setIsLoaded(true)
        } catch (e) {
            setIsLoaded(true)
            console.log(e)
        }
    }

    useEffect(() => {
            getTopProducts().catch(e => console.log(e));
        },
        /* eslint-disable react-hooks/exhaustive-deps */
        [topProductsRange]);

    return <div className={"flex flex-col sl-gap-10 container sl-m-auto "}>
        <div className={" flex flex-row justify-between"}>
                <span
                    className={"sl-text-left sl-text-gray-900 sl-text-xl sl-font-normal sl-align-self-center"}>Your top product stats</span>
            <DropDownMenu options={defaultDateRange} label={defaultDateRange[1].label} onSelect={setTopProductsRange}/>
        </div>
        <hr/>
        <div className={"flex flex-row sl-gap-5 justify-between"}>
            {!isLoaded && !topProducts.length && [1, 2, 3].map((i, index) => <EmptyTopProductCard key={index}/>)}
            {isLoaded && topProducts.length > 0 && topProducts.map((product) => <TopProductCard {...product}/>)}
            {isLoaded && !topProducts.length && <Card className={"w-full"} style={{height: "176px"}}>
                <div className="items-center justify-center sm:flex sl-gap-8 sl-h-20 ">
                    <span>No Products Selected</span>
                </div>
            </Card>}
        </div>


        {!company?.[VENDOR_CHART_IS_ESSENTIAL] && <div
            className={"sl-p-4 sl-border-1 sl-border-solid sl-bg-warning-25 sl-border-warning-300 sl-border-radius-8 flex flex-row justify-between"}>
            <span
                className={"sl-text-gray-600 sl-font-regular sl-text-md"}>Improve your position and get more bid requests by joining the&nbsp;
                <span className={"sl-font-semibold"}>Shortlister Essentials Program.</span></span>

            <a
                rel="noreferrer"
                target={"_blank"}
                href={`${baseUrl}/plan-and-payment-settings/plans-and-pricing`}
                className={"sl-text-warning-700 sl-font-semibold  flex flex-row justify-between sl-gap-1"}>Learn
                more <ArrowRight
                    className={"sl-m-auto"}
                    size={20}/></a>
        </div>}


        <hr/>
    </div>
}

export default TopProducts;
